module.exports = ->
  (record) ->
    switch record.statement_recordable_type
      when 'Payment' then "/payments/#{record.statement_recordable_id}"
      when 'Transfer' then "/transfers/#{record.statement_recordable_id}"
      else "/transactions/#{record.id}"
